import { Component } from '@angular/core'
import { RouterOutlet } from '@angular/router'

@Component({
  selector: 'app-ti-billing-page',
  templateUrl: 'billing-page.component.html',
  styleUrls: ['billing-page.component.scss'],
  imports: [RouterOutlet],
})
export class AdminBillingPageComponent {}
